import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Carousel from './OwlCarousel/Carousel';
import BannerItem from './Carousel/BannerItem';
import config from '../config';

export default class Banner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      banners: [],
    };

    this.target = this.props.target;
    this.onResized = this.onResized.bind(this);
  }

  onResized() {
    this.forceUpdate();
  }

  componentDidMount() {
    const url = `${config.localeApi}/home_banner/`;

    $.get(url, (response) => {
      this.setState({ banners: response.data });
    });
  }

  componentWillUpdate() {
    this.target.refresh();
  }

  render() {
    const bannerCarouselClassName = 'banner-carousel';
    const banners = this.state.banners.map((banner, index) =>
      <BannerItem
        key={index}
        heading={banner.text_heading}
        caption={banner.text_caption}
        mobileImage={banner.mobile_media_url}
        nonMobileImage={banner.desktop_media_url}
        landingPageUrl={banner.landing_page_url}
      />);

    if (banners.length > 0) {
      return (
        <div className={bannerCarouselClassName}>
          <Carousel
            options={this.target.owlOptions(this.onResized)}
            disableOwlTheme={true}
          >
            {banners}
          </Carousel>
        </div>
      );
    }

    return (<div className={bannerCarouselClassName} />);
  }
}

Banner.propTypes = {
  target: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/Banner.js